import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  PaginationResult,
} from '@ckmk/angular';
import {
  SolutionFetchAllPayload,
  SolutionsResult,
} from '@app/src/app/modules/solution/types/types';
import { TypedDocumentNode } from '@apollo/client';
import { SolutionModel } from '@app/src/app/modules/solution/classes/default/model/solution.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class SolutionsRequestQuery extends AbstractGraphqlRequest<
  SolutionsResult,
  { payload: SolutionFetchAllPayload }
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findAllSolutions($payload: SolutionRequestPayloadInput) {
        findAllSolutions(payload: $payload) {
          pagination {
            hasNext
            hasPrevious
            limit
            page
            total
            totalPage
          }
          result {
            id
            category {
              id
              title
              description
              shortDescription
              slug
            }
            cover {
              id
              name
              extension
              directory
              directories
              frontUrls
              mimetype
            }
            picture {
              id
              name
              extension
              directory
              directories
              frontUrls
              mimetype
            }
            slug
            title
            description
            shortDescription
            active
            createdAt
            updatedAt
            deletedAt
            createdBy
            updatedBy
          }
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let { pagination, result } = data.findAllSolutions;

    if (pagination) {
      pagination = new PaginationResult(pagination);
    }

    result = result.map((grp: any) => new SolutionModel(grp));

    return { result, pagination };
  }
}
